module.exports = __webpack_public_path__ + "static/shireen-0ade8b4074333a7022c6c2a219b9f458.jpg";